module.exports = __webpack_public_path__ + "img/icon-extensions.fbf7b80e.png";